import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/contexts/Auth'
import { useClient } from '@/contexts/Services'

/** Tenants the signed-in user can access (`GET /master/tenant-client/tenants`). */
export function useMyTenants() {
  const client = useClient()
  const { user } = useAuth()

  const { data, isLoading } = useQuery({
    queryKey: ['tenants', 'mine'],
    queryFn: () => client!.tenantClient.getTenants(),
    staleTime: 5 * 60 * 1000, // 5 min
    enabled: !!client && !!user,
  })

  return { tenants: data ?? [], isLoading }
}
